import React, {useState} from 'react';


function RepeatedEnumEditorGoogleAttributes ({googleAttribute, cmAttribute, onChange, onDelete}){
    const [selectedOptions, setSelectedOptions] = useState([]);

    const alreadySelected = cmAttribute.repeatedEnumValue ? cmAttribute.repeatedEnumValue.setValues : []

    const handleClick = () => {
        onDelete(cmAttribute)
    }

    const handleOptionChange = (e) => {
        const allSelected = new Set(e.target.checked ? selectedOptions.concat([e.target.value]) : selectedOptions.filter(val =>  val != e.target.value) )
        const notSelected = googleAttribute.valueMetadata.map(metadata=> metadata.value).filter(val => !allSelected.has(val))
        setSelectedOptions([...allSelected])
        const cmGoogleAttribute = {attributeId: googleAttribute.attributeId,
            valueType: googleAttribute.valueType,  repeatedEnumValue: {setValues: [...allSelected], unsetValues: notSelected}}

        onChange(cmGoogleAttribute)
    };

    return <div>
        <table style={{"width": "100%"}}>
            <tbody style={{"width": "100%"}}>
            <tr>
                <td style={{"width": "180px"}}>{/* Set width on first column so everything lines up nicely */}{googleAttribute.displayName}</td>
                <td style={{"width": "200px"}}>
                    {googleAttribute.valueMetadata.map(metadata => {
                        return   <div className="custom-control custom-checkbox control-spacer-left" key={metadata.displayName}>
                            <input type="checkbox" id={metadata.value} value={metadata.value} className="custom-control-input" checked={alreadySelected?.includes( metadata.value)}  onChange={handleOptionChange} key={metadata.displayName +"-checkbox"} />
                            <label className="custom-control-label" key={metadata.displayName +"-label"} htmlFor={metadata.value}>{metadata.displayName}</label>
                        </div>
                    })}
                </td>
                <td>
                    <label>
                        <button type="button" className="btn btn-light" key={"deleteButton"}
                                onClick={handleClick}>
                            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-x-circle-fill"
                                 fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd"
                                      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.146-3.146a.5.5 0 0 0-.708-.708L8 7.293 4.854 4.146a.5.5 0 1 0-.708.708L7.293 8l-3.147 3.146a.5.5 0 0 0 .708.708L8 8.707l3.146 3.147a.5.5 0 0 0 .708-.708L8.707 8l3.147-3.146z"/>
                            </svg>
                        </button>
                    </label>
                </td>
            </tr>
            </tbody>
        </table>
        {alreadySelected?.length == 0 && <small id="boolError" className="text-danger">
            Must make a selection.
        </small>}
    </div>
}

export default RepeatedEnumEditorGoogleAttributes;